<nx-ng-action-button
  [id]="'basket-add-item'"
  [buttonLabelKey]="label"
  class="basket-add-item"
  (click)="handleClick($event)"
>
</nx-ng-action-button>
